const LAST_COMMENTS = {
  PAGE_LIMIT: 50,
  PAGE_SLUG: 'pagina',
  VALID_COMMENT_SOURCES: [
    {
      displayName: 'Todos',
      gaEventActionId: 'all',
      legacySlug: 'all',
      name: 'any',
      slug: null,
    },
    {
      displayName: 'Ofertas',
      gaEventActionId: 'offers',
      legacySlug: 'ofertas',
      name: 'offers',
      slug: 'ofertas',
    },
    {
      displayName: 'Fórum',
      gaEventActionId: 'forum',
      legacySlug: 'topicos',
      name: 'threads',
      slug: 'forum',
    },
    {
      displayName: 'Blog',
      gaEventActionId: 'blog',
      legacySlug: 'posts',
      name: 'articles',
      slug: 'blog',
    },
  ],
};

export default LAST_COMMENTS;
